let getCookie = function (cname) {
    if (document.cookie.length > 0) {
        let cstart = document.cookie.indexOf(cname + '=')
        if (cstart !== -1) {
            cstart = cstart + cname.length + 1
            let cend = document.cookie.indexOf(';', cstart)
            if (cend === -1) {
                cend = document.cookie.length
            }
            return unescape(document.cookie.substring(cstart, cend)).replace(/"/g, '')
        }
    }
    return ''
}
export default getCookie
